import React, { useState } from 'react';
import { Box, Button, CircularProgress, Tooltip } from '@mui/material';
import GetAppIcon from '@mui/icons-material/GetApp';
import { useDispatch } from 'react-redux';
import { showToast } from '@/features/toast/toastSlice';

/**
 * The tables' "Export" toolbar button. Runs onExport (which gathers the rows and calls
 * downloadCsv), shows a spinner until it finishes, and shows an error toast if it throws.
 */
export const ExportCsvButton = ({ onExport, disabled = false }) => {
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);

	const handleClick = async () => {
		setLoading(true);
		try {
			await onExport();
		} catch (error) {
			console.error('Export failed', error);
			dispatch(
				showToast({
					message: 'Error running export; please try again.',
					error: true,
				}),
			);
		} finally {
			setLoading(false);
		}
	};

	return (
		<Tooltip title='Export data as CSV'>
			<Box>
				<Button
					disabled={disabled || loading}
					variant='text'
					size='small'
					endIcon={loading ? <CircularProgress size='1em' color='white' /> : <GetAppIcon />}
					onClick={handleClick}
				>
					Export
				</Button>
			</Box>
		</Tooltip>
	);
};
